/* Forged Racing — homepage / card interactivity.
   - [data-frg-add] anywhere → add single-variant product via window.ForgedCart
   - featured product block: variant pills, qty stepper, add to cart */
(function () {
  'use strict';

  function addToCart(id, qty) {
    if (window.ForgedCart && typeof window.ForgedCart.addItem === 'function') {
      window.ForgedCart.addItem({ id: parseInt(id, 10), quantity: qty || 1 });
    } else {
      /* fallback: hard post then go to cart */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id, 10), quantity: qty || 1 })
      }).then(function () { window.location.href = '/cart'; });
    }
  }

  function init() {
    /* card add-to-cart (delegated) */
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-frg-add]');
      if (!add || add.closest('[data-forged-cart]')) return; /* cart drawer handles its own */
      e.preventDefault();
      add.classList.add('is-loading');
      /* ROUND 88: a pre-order card (data-frg-preorder) flags its line so the
         cart drawer labels it "Pre-order" straight away, as the PDP does. */
      if (add.hasAttribute('data-frg-preorder') && window.ForgedCart && window.ForgedCart.markBackordered) {
        window.ForgedCart.markBackordered(add.dataset.frgAdd, true);
      }
      addToCart(add.dataset.frgAdd, 1);
      setTimeout(function () { add.classList.remove('is-loading'); }, 800);
    });

    /* featured product blocks */
    document.querySelectorAll('[data-frg-featured]').forEach(function (root) {
      var current = root.dataset.frgVariant;
      var qty = 1;
      var qtyEl = root.querySelector('[data-frg-qty-val]');
      var addBtn = root.querySelector('[data-frg-featured-add]');

      root.querySelectorAll('[data-frg-variant]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          root.querySelectorAll('[data-frg-variant]').forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          current = pill.dataset.frgVariant;
          var price = pill.dataset.frgPrice;
          var priceEl = root.querySelector('[data-frg-featured-price]');
          if (price && priceEl) priceEl.textContent = price;
          if (addBtn) addBtn.disabled = pill.dataset.frgAvailable === 'false';
        });
      });

      root.querySelectorAll('[data-frg-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          qty = Math.max(1, qty + parseInt(btn.dataset.frgQty, 10));
          if (qtyEl) qtyEl.textContent = qty;
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (!current) return;
          addToCart(current, qty);
        });
      }

      /* image cycling — same interaction shape as the PDP gallery
         (assets/forged-product.js), scoped to this section's own images */
      var gallery = root.querySelector('[data-frg-featured-gallery]');
      if (gallery) {
        var images = Array.prototype.slice.call(gallery.querySelectorAll('[data-frg-featured-media]'));
        var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-frg-featured-dot]'));
        var galleryIdx = 0;
        function showImage(i) {
          if (!images.length) return;
          galleryIdx = (i + images.length) % images.length;
          images.forEach(function (img, ii) { img.classList.toggle('is-active', ii === galleryIdx); });
          dots.forEach(function (dot, di) { dot.classList.toggle('is-active', di === galleryIdx); });
        }
        dots.forEach(function (dot) { dot.addEventListener('click', function () { showImage(parseInt(dot.dataset.frgFeaturedDot, 10)); }); });
        var galleryPrev = gallery.querySelector('[data-frg-featured-prev]');
        var galleryNext = gallery.querySelector('[data-frg-featured-next]');
        if (galleryPrev) galleryPrev.addEventListener('click', function () { showImage(galleryIdx - 1); });
        if (galleryNext) galleryNext.addEventListener('click', function () { showImage(galleryIdx + 1); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
